
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

import { SelectOptions } from '@/interfaces/SelectOptions';
import cx from '@/utils/classes';

@Component
export default class SelectBox extends Vue {
  @Prop({ type: String }) public id!: string;
  @Prop({ type: String, default: undefined }) public name!: string;
  @Prop({ type: String, default: '' }) public text!: string;
  @Prop({ type: [String, Number], default: undefined }) public value!: string;
  @Prop({ type: Array, default: () => [] }) public options!: SelectOptions[];
  @Prop({ type: Boolean, default: false }) public required!: boolean;
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;

  get selectClasses() {
    return cx('select-box', 'has-float-label');
  }

  get isRequiredWithNoValue() {
    return this.required && !this.value;
  }

  @Emit()
  public onSelect(event: Event) {
    const t = event.target as HTMLSelectElement;
    return { value: t.value, name: this.name };
  }
}
